import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, hasMinimumPlanType, i18nIntl } from '../../lib/ep.js';

import ActionButton, { MainButton, SecondaryButton } from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection.js';
import FloatingLayer from '../builder/FloatingLayer';
import Model from '../builder/Model';
import SectionTitle from '../builder/SectionTitle';
import SectionSubtitle from '../builder/SectionSubtitle.js';
import Spinner from '../builder/Spinner.js';
import Range from '../builder/Range.js';
import Select from '../builder/Select.js';
import Input from '../builder/Input.js';

import BulkFromFile from '../utils/BulkFromFile.js';
import Message, { AlertMessage } from '../builder/Message.js';

//const fake_questions = "Pregunta\tRespuesta1\tRespuesta2\tRespuesta3\n\u00bfQui\u00e9n es el m\u00e1ximo goleador de la historia del Bar\u00e7a?\tMessi\tCruyff\tMaradona\n\u00bfEn qu\u00e9 temporada debut\u00f3 Messi con el Bar\u00e7a?\t2004\/05\t2005\/06\t2006\/07\n\u00bfQui\u00e9n es conocido como 'El jefe' en el Bar\u00e7a?\tPuyol\tXavi\tIniesta\n\u00bfCu\u00e1l es el estadio donde juega el Bar\u00e7a?\tCamp Nou\tSantiago Bernab\u00e9u\tWanda Metropolitano\n\u00bfCu\u00e1l es el apodo del Bar\u00e7a?\tBlaugrana\tColchoneros\tMerengues\n\u00bfQui\u00e9n es el actual entrenador del Bar\u00e7a?\tRonald Koeman\tPep Guardiola\tLuis Enrique\n\u00bfEn qu\u00e9 a\u00f1o gan\u00f3 su primer t\u00edtulo internacional el Bar\u00e7a?\t1958\t1960\t1962\n\u00bfCu\u00e1ntas Ligas de Campeones ha ganado el Bar\u00e7a?\t5\t3\t4\n\u00bfCu\u00e1l es el club eterno rival del Bar\u00e7a?\tReal Madrid\tAtl\u00e9tico de Madrid\tValencia\n\u00bfQui\u00e9n es el jugador con m\u00e1s partidos jugados en la historia del Bar\u00e7a?\tXavi Hern\u00e1ndez\tIniesta\tPuyol";
const fake_words = JSON.parse('[["Word","Hint"],["Regreso al Futuro","Viaje en el tiempo con Marty McFly"],["Los Goonies","Grupo de amigos en busca de un tesoro"],["E.T. El Extraterrestre","Amistad inolvidable entre un ni\u00f1o y un extraterrestre"],["Indiana Jones y los cazadores del arca perdida","Aventuras de un arque\u00f3logo en busca de reliquias"],["El resplandor","Thriller psicol\u00f3gico en un hotel aislado"]]');

const AIPalorderGenerator = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props?.promotion ?? {};

	const getLangName = (lang) => {
		if(window.locales == undefined) return "Not defined";

		const lang_name = window.locales[lang];
		if(lang_name != undefined) return lang_name;

		return "Not defined";
	};

	const available_langs_to_add = [{ k:promotion?.default_locale ?? 'eng', v:getLangName(promotion?.default_locale ?? 'eng') }];
	(window?.promoLocales ?? []).map((lang) => {
		available_langs_to_add.push({ k:lang.I18nPromotion.lang, v:getLangName(lang.I18nPromotion.lang) });
	});

	const promotion_id = promotion?.id ?? false;

	const default_ai = {
		text:'',
		num_words:5,
		language:available_langs_to_add[0].k,
		model:'gpt-3.5-turbo',
		words:null,
		type:'palorder',
		stage_id:props?.stage_id ?? null
	};

	const [ ai, setAi ] = useState(default_ai);
	const [ searchingAI, setSearchingAI ] = useState(false);
	const [ step_2, setStep2 ] = useState(false);
	const [ api_error, setApiError ] = useState(false);
	const [ already, setAlready ] = useState([]);

	if(promotion_id === false) return null;

	const models_gpt = [
		{ k:'gpt-3.5-turbo', v:i18n("GPT 3.5 Turbo") },
		{ k:'gpt-4', v:i18n("GPT 4 (Slow)") },
	];

	const close = () => {
		if(props.close != undefined) props.close();
	};

	const available_to_search = (ai.text.length > 3) ? true : false;

	const change = (k, v) => {
		setAi({ ...ai, [k]:v });
	};

	const searchAI = (cb) => {
		if(false) {
			setAi({ ...default_ai, ['words']:fake_words });
			setStep2(true);
			return;
		}

		setSearchingAI(true);

		let type = 'ai_palorder';
		$.post({
			url:getRemotedbUrl(`/promotions/search_ai/${promotion_id}`),
			data:{ ...ai, ...{'words':[]}},
			dataType:'JSON',
			success:(r) => {
				setSearchingAI(false);

				if(r.status == 1  && r.words != undefined) {
					setAi({ ...ai, ...{'words':r.words}});
					if(r.already)setAlready(r.already)
					setStep2(true);
				} else {
					//alert(`Api Error: ${r.error}`);
					setApiError(true);
				}
			
				if(cb != undefined)cb();
			},
			error:(jqXHR, textStatus, errorThrown) => {
				// Handle error
				close();
				setSearchingAI(false);
				
				let track_data = {};
				track_data.error = `JS ERROR: ${errorThrown}`;
				track_data.ai = ai;
				$.post(`/sweeps/track_error_log/${type}/${promotion_id}`, track_data,'JSON');

				setApiError(true);
			}
		});
	};

	
	return (
		<FloatingLayer
			backButton={(!searchingAI) ? () => close() : null}
			_class={{ size:(!step_2) ? 'small' : 'big' }}
			enable_close={(!searchingAI) ? true : false}
		>
			{(!step_2) && (
				<div>
					<SectionTitle>AI Word Generator</SectionTitle>

					<SectionSubtitle>Generate your own words through Artificial Intelligence.</SectionSubtitle>

					{(api_error) ? (
						<AlertMessage>
							<p>{i18n("Error connecting to the AI, please try again in a few minutes, and if the problem persists, contact support.")}</p>
						</AlertMessage>
					) : (
						<Model model={ai} change={change}>
							<Input
								name="text"
								max_length={50}
							>Topic of the words</Input>

							<Select
								name="language"
								values={available_langs_to_add}
								_class={{ size:60 }}
							>Select a language</Select>

							{/*<Select
								name="model"
								_class={{ size:60 }}
								values={models_gpt}
							>Model</Select>*/}

							<Range
								min={2}
								max={20}
								value={parseInt(ai?.num_words ?? 1)}
								name="num_words"
								default={1}
								step={1}
								_class={{ size:60 }}
							>Number of words</Range>
						</Model>
					)}

					{(searchingAI) && (
						<Spinner
							autotranslate={false}
							force_bg={true}
						>{`${i18n("AI in process, please wait. This could take a while")}...`}</Spinner>
					)}

					<ButtonCollection in_floating={true}>
					{(!api_error) && (
						<ActionButton
							onClick={() => searchAI()}
							disabled={!available_to_search}
						>Generate words</ActionButton>
					)}

						<SecondaryButton
							onClick={() => close()}
							autotranslate={false}
						>{i18n("Close")}</SecondaryButton>
					</ButtonCollection>
				</div>
			)}

			{(step_2) && (
				<div>
					<SectionTitle>AI Word Generator</SectionTitle>

					<BulkFromFile
						title="Import your words/clues"
						subtitle="You can import up to {max} words/clues in bulk."
						promotion_id={promotion.id}
						type="guess_word"
						import_from_ai={true}
						type_import='upload'
						text={ai.words}
						already={already}
						onSuccess={(w) => {
							props.onSuccess(w);
							close();
						}}
						close={()=>close()}
						fields={[
							{ name:'name', icon:'knk-anagram', label:i18n("Word or sentence"), position:1 },
							{ name:'description', icon:'knk-search', label:i18n("Clue"), position:2 },
						]}
						instructions={<><p>{i18n("Create a CSV or text file with two columns, separated by a comma or semicolon. The first column corresponds to the name of the validation point, and the second column the access password.")}</p><p>{i18n("Each line corresponds to a validation point.")}</p></>}
						confirm_label="Add to game"
						extra_msg={<Message _class={{ other:'in_bottom'}}>
							<p>{i18n("If there are many repeated words, specify the topic more and generate new ones")}.</p>
						</Message>}
					/>
				</div>
			)}
		</FloatingLayer>
	);
}

export default injectIntl(AIPalorderGenerator);